import {IFormulaNode} from '@mintdata-wsp/common/controllers/spreadsheet/formula/ast/FormulaDefinitions';
import {FormulaType} from '@mintdata-wsp/common/controllers/spreadsheet/formula/engine/FormulaType';
import {IFormulaToken} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/FormulaToken';

export class OhmParseResult
{
    public constructor(public isParseSuccessful:boolean,
                       public rootNode:IFormulaNode,
                       public formulaType:FormulaType,
                       public errorMessage:string)
    {
    }

    public isLazyFormula():boolean
    {
        return this.formulaType === FormulaType.LazyFormula || this.formulaType === FormulaType.LiveFormula;
    }

    public isLiveFormula():boolean
    {
        return this.formulaType === FormulaType.LiveFormula;
    }

    public isAccumulative():boolean
    {
        return this.rootNode && (this.rootNode as any).accumulateResult;
    }
}

export class OhmParseInputResult
{
    public constructor(public isParseSuccessful:boolean,
                       public result:Array<IFormulaToken> | IFormulaToken,
                       public errorMessage:string)
    {
    }
}
